import { getConfig } from '@constants';

export const getDisplayMode = () => {
	if (getConfig().isTwa) {
		return 'twa';
	} else if (window) {
		const isStandalone = window.matchMedia('(display-mode: standalone)').matches;

		if (navigator && navigator.standalone || isStandalone) {
			return 'standalone';
		}
	}
	return 'browser';
};
